export default __webpack_public_path__ + "static/media/chill.51a7c40f.png";